import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        meta: {
            title: '',
            icon: ''
        },
        redirect: 'home' //重定向
    },
    {
        path: '/home',
        name: 'home',
        meta: {
            title: '文昌鸡产品溯源',
            icon: ''
        },
        component: () => import('../views/home.vue')
    
    },
    {
        path: '/home1',
        name: 'home1',
        meta: {
            title: '文昌鸡产品溯源',
            icon: ''
        },
        component: () => import('../views/project1/home_project1.vue')
    },
    {
        path: '/home2',
        name: 'home2',
        meta: {
            title: '文昌鸡产品溯源',
            icon: ''
        },
        component: () => import('../views/project2/home_project2.vue')
    },
    {
        path: '/home3',
        name: 'home3',
        meta: {
            title: '文昌鸡产品溯源',
            icon: ''
        },
        component: () => import('../views/project3/home_project3.vue')
    },
    {
        path: '/home4',
        name: 'home4',
        meta: {
            title: '健康肉溯源',
            icon: ''
        },
        component: () => import('../views/project4/home_project4.vue')
    },
    {
        path: '/home6',
        name: 'home6',
        meta: {
            title: '文昌鸡产品溯源',
            icon: ''
        },
        component: () => import('../views/project6/home_project6.vue')
    },
    {
        path: '/home6',
        name: 'home6',
        meta: {
            title: '文昌鸡产品溯源',
            icon: ''
        },
        component: () => import('../views/project6/home_project6.vue')
    },
    {
        path: '/home7',
        name: 'home7',
        meta: {
            title: '文昌鸡产品溯源',
            icon: ''
        },
        component: () => import('../views/project7/home_project7.vue')
    },
    {
        path: '/home8',
        name: 'home8',
        meta: {
            title: '文昌鸡产品溯源',
            icon: ''
        },
        component: () => import('../views/project8/home_project8.vue')
    },
    {
        path: '/ct',
        name: 'commonTrace',
        meta: {
            title: '产品溯源',
            icon: ''
        },
        component: () => import('../views/commonTrace')
    },
    {
        path: '/ctSearch',
        name: 'ctSearch',
        meta: {
            title: '扫一扫',
            icon: ''
        },
        component: () => import('../views/ctSearch/ctSearch.vue')
    }
   
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router
